const t = {
  "empty-state": "empty-state"
};
export {
  t as default
};
